import React, { useEffect } from "react";
import EnvioFacturasStep1 from '../../Resources/Images/Tutoriales/EnvioFacturas/EnvioFacturas-1.jpg';
import StepTutorial from './index-step';

function getSteps() {
    return ['Paso 1'];
}

function getStepContent(stepIndex) {
    switch (stepIndex) {
        case 0:
            return <StepTutorial image={EnvioFacturasStep1} text={[
                'Seleccionar el sector: "Envío de Factura"',
                'Escribir un mensaje y el asunto del mismo',
                'Si es necesario, agregar un archivo adjunto',
                'Si se desea, seleccionar “Recibir copia en mi e-mail”',
                'Hacer clic en “Enviar consulta” para que sea recibida por el sector correspondiente'
            ]} />;
        default:
            return '¡Tutorial completado!';
    }
}

export function EnvioFacturas({ activeStep, setSteps }) {
    const steps = getSteps();

    useEffect(() => {
        setSteps(steps);
    }, [setSteps, steps]);

    return (
        <>
            <h2>Envío de Facturas</h2>

            {/* Stepper Bootstrap */}
            <div className="d-flex justify-content-center mb-4">
                {steps.map((label, index) => (
                    <div
                        key={label}
                        className={`text-center mx-2 px-3 py-2 rounded ${index === activeStep ? 'bg-primary text-white' : 'bg-light text-secondary'}`}
                        style={{ minWidth: 80 }}
                    >
                        <div className="fw-bold">{label}</div>
                        <div className="small">Paso {index + 1}</div>
                    </div>
                ))}
            </div>

            <div>
                {getStepContent(activeStep)}
            </div>
        </>
    );
}
